function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40",
  fill: "none",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  stroke: "currentColor",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M18.7 19.16h-1m1-3h-1m4.43 3h-1m1-3h-1m1-3.06h-1M18.7 32.73h-1m1-3h-1m4.43 3.03h-1m1-3h-1M16.62 6a4.56 4.56 0 016.76 0m-5.26 1.5a2.73 2.73 0 013.76 0",
  className: styles["cls-1"] || "cls-1"
}), /*#__PURE__*/React.createElement("rect", {
  width: "25",
  height: "9",
  x: "7.5",
  y: "18.49",
  className: styles["cls-2"] || "cls-2",
  rx: "1.99",
  transform: "rotate(90 20 22.99)"
}), /*#__PURE__*/React.createElement("rect", {
  width: "4.65",
  height: "4.65",
  x: "17.58",
  y: "22.11",
  className: styles["cls-2"] || "cls-2",
  rx: ".85",
  transform: "rotate(90 19.91 24.43)"
}));